import { parse, format, isValid } from "date-fns";

type defaultFormatType = "dd/MM/yyyy" | "dd/MM/yyyy HH:mm:ss" | "yyyy-MM-dd" | "yyyy-MM-dd'T'HH:mm:ss";

export class DateUtil {

    static fromString(date: string, format: defaultFormatType): Date {
        return parse(date, format, new Date());
    }

    static format(date: Date, pattern: defaultFormatType): string {
        return format(date, pattern);
    }

    static toOtherFormat(date: string, sourceFormat: defaultFormatType, targetFormat: string): string {
      const parsed = parse(date, sourceFormat, new Date());
      return format(parsed, targetFormat);
    }

    static normalizeToIsoDate(value: string | Date | null | undefined): string | undefined {
      if (!value) {
        return undefined;
      }

      if (value instanceof Date) {
        const ano = value.getFullYear();
        const mes = String(value.getMonth() + 1).padStart(2, '0');
        const dia = String(value.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
      }

      const valor = String(value).trim();
      if (!valor) {
        return undefined;
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
        const parsed = parse(valor, 'dd/MM/yyyy', new Date());
        return isValid(parsed) && format(parsed, 'dd/MM/yyyy') === valor
          ? format(parsed, 'yyyy-MM-dd')
          : undefined;
      }

      return valor;
    }
}
